import './walkme-modal.css';

const Walkme = () => {
  return (
        <div style={{display:'none'}}>
                <div id="cdk-walkme-menu" className="cdk-walkme-menu" ></div>
        </div>
        )
  }

export const resetWalkme =() =>{
    let menu = document.getElementById('walkme-menu') as any;
    if(menu){
        document.getElementById('cdk-walkme-menu')?.appendChild(menu);
    }
}

export default Walkme; 